import label from "@/lang/StaticLabels.js";
import { RUNTIME_ENV } from "@/runtimeEnv";
import { EventBus } from "@/plugins/eventBus.js";
import { setPACNTFloatAccountOperationDetailLabels } from "@/router/modules/pacnt.js";
import { setPACNTFloatAccountBalanceLabels } from "@/router/modules/pacnt.js";

// PACNT Navbar  - حسابداری  -----------------------------------------------
let navItems = [
  {
    title: label.modules.pacnt,
    to: false,
  },
  {
    to: "PACNTDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PACNTAccountConfig",
        label: label.menu.accountConfig,
        metaLabel: label.page.accountConfig,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTAccountInfo",
        label: label.menu.accountInfo,
        metaLabel: label.page.accountInfo,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTAccountControlConfig",
        label: label.menu.accountControlConfig,
        metaLabel: label.page.accountControlConfig,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTVoucherNoteType",
        label: label.menu.voucherNoteType,
        metaLabel: label.page.voucherNoteType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTDefaultVoucherDescription",
        label: label.menu.defaultVoucherDescription,
        metaLabel: label.page.defaultVoucherDescription,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTFinancialRatio",
        label: label.menu.financialRatioSetting,
        metaLabel: label.page.financialRatioSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PACNTPersonCredit",
        label: label.menu.personCredit,
        metaLabel: label.page.personCredit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.voucher,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTAddVoucher",
            label: label.menu.addVoucher,
            metaLabel: label.page.addVoucher,
            icon: "mdi-circle-medium",
          },
          {
            to: "PACNTAddVoucherNew",
            label: label.menu.addVoucherNew,
            metaLabel: label.page.addVoucherNew,
            icon: "mdi-circle-medium",
          },
          {
            to: "PACNTVoucherList",
            label: label.menu.voucherList,
            metaLabel: label.page.voucher,
            icon: "mdi-circle-medium",
          },
        ],
      },
      {
        to: "PACNTVoucherReview",
        label: label.menu.voucherReview,
        metaLabel: label.page.voucherReview,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.voucherCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTVoucherVerification",
            label: label.menu.voucherVerification,
            metaLabel: label.page.voucherVerification,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTArchiveVoucher",
            label: label.menu.archiveVoucher,
            metaLabel: label.page.archiveVoucher,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTVoucherConfirm",
            label: label.menu.voucherConfirm,
            metaLabel: label.page.voucherConfirm,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTVoucherSort",
            label: label.menu.voucherSort,
            metaLabel: label.page.voucherSort,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTVoucherMerge",
            label: label.menu.voucherMerge,
            metaLabel: label.page.voucherMerge,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTManagementCartableVoucher",
            label: label.menu.vouchers,
            metaLabel: label.page.managementCartableVoucher,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PACNTDebtorOrCreditorDeclarationList",
        label: label.menu.debtorOrCreditorDeclaration,
        metaLabel: label.page.debtorOrCreditorDeclaration,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PACNTGroupChangeVoucherArticles",
        label: label.menu.groupChangeVoucherArticles,
        metaLabel: label.page.groupChangeVoucherArticles,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PACNTCloseAccounts",
        label: label.menu.closeAccounts,
        metaLabel: label.page.closeAccounts,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.officeReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTAccountOperationDetailReport",
            label: label.menu.accountOperationDetailReport,
            metaLabel: label.page.accountOperationDetailReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTElectronicLedgerReport",
            label: label.menu.electronicLedgerReport,
            metaLabel: label.page.electronicLedgerReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTJournalReport",
            label: label.menu.journalReport,
            metaLabel: label.page.journalReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTCirculationOfAccounts",
            label: label.menu.circulationOfAccounts,
            metaLabel: label.page.circulationOfAccounts,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTAccountOffice",
            label: label.menu.accountOffice,
            metaLabel: label.page.accountOffice,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTMonthlyAccountingVoucherReport",
            label: label.menu.monthlyAccountingVoucherReport,
            metaLabel: label.page.monthlyAccountingVoucherReport,
            icon: "mdi-circle-small",
          },
          // {
          //   to: "PACNTAccountCurrencyMonitoringReport",
          //   label: label.menu.accountCurrencyMonitoringReport,
          //   metaLabel: label.page.accountCurrencyMonitoringReport,
          //   icon: "mdi-circle-small",
          // },
        ],
      },
      {
        to: null,
        label: label.menu.reportsOfIndividuals,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTIndividualOperationDetailReport",
            label: label.menu.individualOperationDetailReport,
            metaLabel: label.page.individualOperationDetailReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTAccountWithPersonReport",
            label: label.menu.acountsWithPersonReport,
            metaLabel: label.page.acountsWithPersonReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonWithAccount",
            label: label.menu.personWithAccount,
            metaLabel: label.page.personWithAccount,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonCreditsReport",
            label: label.menu.personCreditsReport,
            metaLabel: label.page.personCreditsReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonalAccountBalanceReport",
            label: label.menu.personalAccountBalanceReport,
            metaLabel: label.page.personalAccountBalanceReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonOfficeReport",
            label: label.menu.personOfficeReport,
            metaLabel: label.page.personOfficeReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonMultiLevelLedgerReport",
            label: label.menu.personMultiLevelLedgerReport,
            metaLabel: label.page.personMultiLevelLedgerReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTPersonFinalVoucherReport",
            label: label.menu.personalFinalVoucherReport,
            metaLabel: label.page.personalFinalVoucherReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.trialBalances,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTTrialBalance4ColumnsReport",
            label: label.menu.trialBalance4ColumnsReport,
            metaLabel: label.page.trialBalance4ColumnsReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTTrialBalance6ColumnsReport",
            label: label.menu.trialBalance6ColumnsReport,
            metaLabel: label.page.trialBalance6ColumnsReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTTrialBalance8ColumnsReport",
            label: label.menu.trialBalance8ColumnsReport,
            metaLabel: label.page.trialBalance8ColumnsReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTTrialBalanceReport",
            label: label.menu.trialBalanceReport,
            metaLabel: label.page.trialBalanceReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTAccountCurrencyTrialBalanceReport",
            label: label.menu.accountCurrencyTrialBalanceReport,
            metaLabel: label.page.accountCurrencyTrialBalanceReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.floatAccountReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTAccountWithFloatAccount",
            label: label.menu.accountWithFloatAccount,
            metaLabel: label.page.accountWithFloatAccount,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: "PACNTAccountWithFloatAccountGroupReport",
            label: label.menu.accountWithFloatAccountGroupReport,
            metaLabel: label.page.accountWithFloatAccountGroupReport,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: "PACNTFloatAccountWithAccount",
            label: label.menu.floatAccountWithAccount,
            metaLabel: label.page.floatAccountWithAccount,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: "PACNTPersonWithFloatAccount",
            label: label.menu.personWithFloatAccount,
            metaLabel: label.page.personWithFloatAccount,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: "PACNTFloatAccountWithPerson",
            label: label.menu.floatAccountWithPerson,
            metaLabel: label.page.floatAccountWithPerson,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: "PACNTFloatAccountOffice",
            label: label.menu.floatAccountOffice,
            metaLabel: label.page.floatAccountOffice,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: null,
            label: label.menu.floatAccountOperationDetail,
            icon: "mdi-circle-small",
            subItems: [],
          },
          {
            to: null,
            label: label.menu.floatAccountBalance,
            icon: "mdi-circle-small",
            subItems: [],
          },
        ],
      },
      {
        to: null,
        label: label.menu.worksheetReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTProfitAndLossReport",
            label: label.menu.profitAndLoss + " / " + label.menu.balanceSheet,
            metaLabel: label.page.profitAndLossReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.other,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PACNTFinancialRatioReport",
            label: label.menu.financialRatioReport,
            metaLabel: label.page.financialRatioReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PACNTVoucherNotesReport",
            label: label.menu.voucherNotesReport,
            metaLabel: label.page.voucherNotesReport,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
];

function setFloatAccountOperationDetailSubItems(floatAccount) {
  const reports = navItems.find((item) => item.label === label.menu.reports);
  if (!reports) return;

  const floatAccountReports = reports.subItems.find(
    (item) => item.label === label.menu.floatAccountReports,
  );
  if (!floatAccountReports) return;

  const floatAccountItem = floatAccountReports.subItems.find(
    (item) => item.label === label.menu.floatAccountOperationDetail,
  );

  if (!floatAccountItem) return;

  floatAccountItem.subItems = [
    {
      to: "PACNTFloatAccountOperationDetailLevelOne",
      label: label.menu.operationDetail + " " + (floatAccount[0]?.title || ""),
      metaLabel:
        label.menu.operationDetail + " " + (floatAccount[0]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountOperationDetailLevelTwo",
      label: label.menu.operationDetail + " " + (floatAccount[1]?.title || ""),
      metaLabel:
        label.menu.operationDetail + " " + (floatAccount[1]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountOperationDetailLevelThree",
      label: label.menu.operationDetail + " " + (floatAccount[2]?.title || ""),
      metaLabel:
        label.menu.operationDetail + " " + (floatAccount[2]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountOperationDetailLevelFour",
      label: label.menu.operationDetail + " " + (floatAccount[3]?.title || ""),
      metaLabel:
        label.menu.operationDetail + " " + (floatAccount[3]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountOperationDetailLevelFive",
      label: label.menu.operationDetail + " " + (floatAccount[4]?.title || ""),
      metaLabel:
        label.menu.operationDetail + " " + (floatAccount[4]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountTextOperationDetail",
      label: label.menu.operationDetail + " " + label.menu.floatAccountText,
      metaLabel: label.menu.operationDetail + " " + label.menu.floatAccountText,
      icon: "mdi-chevron-left",
    },
  ];
}

// function setAccountWithFloatAccountSubItems(floatAccount) {
//   const reports = navItems.find((item) => item.label === label.menu.reports);
//   if (!reports) return;

//   const floatAccountReports = reports.subItems.find(
//     (item) => item.label === label.menu.floatAccountReports,
//   );
//   if (!floatAccountReports) return;

//   const floatAccountItem = floatAccountReports.subItems.find(
//     (item) => item.label === label.menu.accountWithFloatAccount,
//   );
//   if (!floatAccountItem) return;

//   floatAccountItem.subItems = [
//     {
//       to: "PACNTAccountWithFloatAccountLevelOne",
//       label: label.menu.account + "-" + (floatAccount[0]?.title || ""),
//       metaLabel: label.menu.account + "-" + (floatAccount[0]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTAccountWithFloatAccountLevelTwo",
//       label: label.menu.account + "-" + (floatAccount[1]?.title || ""),
//       metaLabel: label.menu.account + "-" + (floatAccount[1]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTAccountWithFloatAccountLevelThree",
//       label: label.menu.account + "-" + (floatAccount[2]?.title || ""),
//       metaLabel: label.menu.account + "-" + (floatAccount[2]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTAccountWithFloatAccountLevelFour",
//       label: label.menu.account + "-" + (floatAccount[3]?.title || ""),
//       metaLabel: label.menu.account + "-" + (floatAccount[3]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTAccountWithFloatAccountLevelFive",
//       label: label.menu.account + "-" + (floatAccount[4]?.title || ""),
//       metaLabel: label.menu.account + "-" + (floatAccount[4]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTAccountWithFloatAccountText",
//       label: label.menu.account + "-" + label.menu.floatAccountText,
//       metaLabel: label.menu.account + "-" + label.menu.floatAccountText,
//       icon: "mdi-chevron-left",
//     },
//   ];
// }

// function setPersonWithFloatAccountSubItems(floatAccount) {
//   const reports = navItems.find((item) => item.label === label.menu.reports);
//   if (!reports) return;

//   const floatAccountReports = reports.subItems.find(
//     (item) => item.label === label.menu.floatAccountReports,
//   );
//   if (!floatAccountReports) return;

//   const floatAccountItem = floatAccountReports.subItems.find(
//     (item) => item.label === label.menu.personWithFloatAccount,
//   );
//   if (!floatAccountItem) return;

//   floatAccountItem.subItems = [
//     {
//       to: "PACNTPersonWithFloatAccountLevelOne",
//       label: label.menu.person1 + "-" + (floatAccount[0]?.title || ""),
//       metaLabel: label.menu.person1 + "-" + (floatAccount[0]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTPersonWithFloatAccountLevelTwo",
//       label: label.menu.person1 + "-" + (floatAccount[1]?.title || ""),
//       metaLabel: label.menu.person1 + "-" + (floatAccount[1]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTPersonWithFloatAccountLevelThree",
//       label: label.menu.person1 + "-" + (floatAccount[2]?.title || ""),
//       metaLabel: label.menu.person1 + "-" + (floatAccount[2]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTPersonWithFloatAccountLevelFour",
//       label: label.menu.person1 + "-" + (floatAccount[3]?.title || ""),
//       metaLabel: label.menu.person1 + "-" + (floatAccount[3]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTPersonWithFloatAccountLevelFive",
//       label: label.menu.person1 + "-" + (floatAccount[4]?.title || ""),
//       metaLabel: label.menu.person1 + "-" + (floatAccount[4]?.title || ""),
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTPersonWithFloatAccountText",
//       label: label.menu.person1 + "-" + label.menu.floatAccountText,
//       metaLabel: label.menu.person1 + "-" + label.menu.floatAccountText,
//       icon: "mdi-chevron-left",
//     },
//   ];
// }

// function setFloatAccountWithPersonSubItems(floatAccount) {
//   const reports = navItems.find((item) => item.label === label.menu.reports);
//   if (!reports) return;

//   const floatAccountReports = reports.subItems.find(
//     (item) => item.label === label.menu.floatAccountReports,
//   );
//   if (!floatAccountReports) return;

//   const floatAccountItem = floatAccountReports.subItems.find(
//     (item) => item.label === label.menu.floatAccountWithPerson,
//   );
//   if (!floatAccountItem) return;

//   floatAccountItem.subItems = [
//     {
//       to: "PACNTFloatAccountWithPersonLevelOne",
//       label: (floatAccount[0]?.title || "") + "-" + label.menu.person1,
//       metaLabel: (floatAccount[0]?.title || "") + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithPersonLevelTwo",
//       label: (floatAccount[1]?.title || "") + "-" + label.menu.person1,
//       metaLabel: (floatAccount[1]?.title || "") + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithPersonLevelThree",
//       label: (floatAccount[2]?.title || "") + "-" + label.menu.person1,
//       metaLabel: (floatAccount[2]?.title || "") + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithPersonLevelFour",
//       label: (floatAccount[3]?.title || "") + "-" + label.menu.person1,
//       metaLabel: (floatAccount[3]?.title || "") + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithPersonLevelFive",
//       label: (floatAccount[4]?.title || "") + "-" + label.menu.person1,
//       metaLabel: (floatAccount[4]?.title || "") + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountTextWithPerson",
//       label: label.menu.floatAccountText + "-" + label.menu.person1,
//       metaLabel: label.menu.floatAccountText + "-" + label.menu.person1,
//       icon: "mdi-chevron-left",
//     },
//   ];
// }

// function setFloatAccountWithAccountSubItems(floatAccount) {
//   const reports = navItems.find((item) => item.label === label.menu.reports);
//   if (!reports) return;

//   const floatAccountReports = reports.subItems.find(
//     (item) => item.label === label.menu.floatAccountReports,
//   );
//   if (!floatAccountReports) return;

//   const floatAccountItem = floatAccountReports.subItems.find(
//     (item) => item.label === label.menu.floatAccountWithAccount,
//   );
//   if (!floatAccountItem) return;

//   floatAccountItem.subItems = [
//     {
//       to: "PACNTFloatAccountWithAccountLevelOne",
//       label: (floatAccount[0]?.title || "") + "-" + label.menu.account,
//       metaLabel: (floatAccount[0]?.title || "") + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithAccountLevelTwo",
//       label: (floatAccount[1]?.title || "") + "-" + label.menu.account,
//       metaLabel: (floatAccount[1]?.title || "") + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithAccountLevelThree",
//       label: (floatAccount[2]?.title || "") + "-" + label.menu.account,
//       metaLabel: (floatAccount[2]?.title || "") + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithAccountLevelFour",
//       label: (floatAccount[3]?.title || "") + "-" + label.menu.account,
//       metaLabel: (floatAccount[3]?.title || "") + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithAccountLevelFive",
//       label: (floatAccount[4]?.title || "") + "-" + label.menu.account,
//       metaLabel: (floatAccount[4]?.title || "") + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//     {
//       to: "PACNTFloatAccountWithAccountText",
//       label: label.menu.floatAccountText + "-" + label.menu.account,
//       metaLabel: label.menu.floatAccountText + "-" + label.menu.account,
//       icon: "mdi-chevron-left",
//     },
//   ];
// }

function setFloatAccountBalanceSubItems(floatAccount) {
  const reports = navItems.find((item) => item.label === label.menu.reports);
  if (!reports) return;

  const floatAccountReports = reports.subItems.find(
    (item) => item.label === label.menu.floatAccountReports,
  );
  if (!floatAccountReports) return;

  const floatAccountItem = floatAccountReports.subItems.find(
    (item) => item.label === label.menu.floatAccountBalance,
  );
  if (!floatAccountItem) return;

  floatAccountItem.subItems = [
    {
      to: "PACNTFloatAccountBalanceLevelOne",
      label: label.menu.trialBalance + " " + (floatAccount[0]?.title || ""),
      metaLabel: label.menu.trialBalance + " " + (floatAccount[0]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountBalanceLevelTwo",
      label: label.menu.trialBalance + " " + (floatAccount[1]?.title || ""),
      metaLabel: label.menu.trialBalance + " " + (floatAccount[1]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountBalanceLevelThree",
      label: label.menu.trialBalance + " " + (floatAccount[2]?.title || ""),
      metaLabel: label.menu.trialBalance + " " + (floatAccount[2]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountBalanceLevelFour",
      label: label.menu.trialBalance + " " + (floatAccount[3]?.title || ""),
      metaLabel: label.menu.trialBalance + " " + (floatAccount[3]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountBalanceLevelFive",
      label: label.menu.trialBalance + " " + (floatAccount[4]?.title || ""),
      metaLabel: label.menu.trialBalance + " " + (floatAccount[4]?.title || ""),
      icon: "mdi-chevron-left",
    },
    {
      to: "PACNTFloatAccountTextBalance",
      label: label.menu.trialBalance + " " + label.menu.floatAccountText,
      metaLabel: label.menu.trialBalance + " " + label.menu.floatAccountText,
      icon: "mdi-chevron-left",
    },
  ];
}

export async function loadPACNTFloatAccountConfigs() {
  try {
    const lang = JSON.parse(localStorage.getItem("mitaLanguage")) || 1;

    const response = await fetch(
      RUNTIME_ENV.VUE_APP_API_URL + "base/api/v1/DropDown/FloatAccountConfigs",
      {
        method: "GET",
        headers: {
          Authorization: localStorage.mitaToken,
          "Content-Type": "application/json",
          fiscalYearId: localStorage.FiscalYearId,
          branchId: localStorage.BranchId,
          dateType: localStorage.DateType,
          dateTimeFormat: localStorage.DateTimeFormat,
          "Accept-Language": lang === 1 ? "fa-IR" : "en-US",
        },
      },
    );

    if (!response.ok) throw new Error("Failed to fetch data from API");

    const result = await response.json();

    setFloatAccountOperationDetailSubItems(result.data);
    setPACNTFloatAccountOperationDetailLabels(result.data);
    setPACNTFloatAccountBalanceLabels(result.data);
    // setAccountWithFloatAccountSubItems(result.data);
    // setPersonWithFloatAccountSubItems(result.data);
    // setFloatAccountWithPersonSubItems(result.data);
    // setFloatAccountWithAccountSubItems(result.data);
    setFloatAccountBalanceSubItems(result.data);
  } catch (error) {
    console.error("PACNT fetch failed:", error);
  }
}
if (localStorage.mitaToken) {
  loadPACNTFloatAccountConfigs();
}
EventBus.$on("floatAccount-change", loadPACNTFloatAccountConfigs);

export default navItems;
